var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevenueBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    fill: "none",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#120693",
    d: "M275.1 464.55c99.041 0 179.33-21.625 179.33-48.3 0-26.675-80.289-48.3-179.33-48.3-99.041 0-179.33 21.625-179.33 48.3 0 26.675 80.289 48.3 179.33 48.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M426.23 310.52H74.54L4.5 380.56m70.26-94.58v-68.15m0 88.73v-13.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    d: "M49.896 264.74s0-4.12 5.76-9.88c5.76-5.76 9.47-9.06 9.47-9.06s2.89 9.48-2.47 15.24c-3.931 4.07-8.2 7.8-12.76 11.15v-7.45Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    d: "M50.73 269.12s.58-4.08-4.31-10.6-8.08-10.32-8.08-10.32-4.18 9 .29 15.44a101.463 101.463 0 0 0 11.06 12.82l1.04-7.34Zm-5.69 23.95s0-4.11 5.77-9.88c5.77-5.77 9.47-9 9.47-9s2.89 9.47-2.47 15.23a100.982 100.982 0 0 1-12.77 11.15v-7.5Zm3.85 21.73s-1-4 3.09-11 6.87-11.15 6.87-11.15 5.18 8.44 1.47 15.37a101.217 101.217 0 0 1-9.54 14l-1.89-7.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177,
    d: "M50.6 270.28c-1.75 13.65-7.08 21.26-5.58 30.38 1.5 9.12 9.5 33.8 9.5 33.8m-4.424-63.86a64.576 64.576 0 0 1 11.15-14.88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177,
    d: "M50.02 272.67a73.365 73.365 0 0 0-5.68-10.71c-3-4.48-3.48-5.06-3.48-5.06m4.18 43.75a69.572 69.572 0 0 1 4.69-9.48 61.54 61.54 0 0 1 6.06-8m-5.02 38.8a17.62 17.62 0 0 1 1.56-9.12c2.17-4.19 4.62-9.69 5.64-11.85"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    d: "M21.64 245.54s-.45-2.57 2.54-6.82 5-6.72 5-6.72 2.83 5.62.1 9.82a64.184 64.184 0 0 1-6.8 8.36l-.84-4.64Zm8.04 15.26s-.45-2.59 2.54-6.83 5-6.71 5-6.71 2.83 5.63.1 9.82a63.53 63.53 0 0 1-6.8 8.36l-.84-4.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    d: "M22.63 249.9s-.7-2.52-5.25-5S10 241 10 241s-.11 6.27 4.18 8.9a64.223 64.223 0 0 0 9.75 4.58l-1.3-4.58Zm9.64 17.95s-1-2.43-5.76-4.46-7.75-3.1-7.75-3.1.55 6.27 5.08 8.41a64.582 64.582 0 0 0 10.18 3.53l-1.75-4.38Zm2.4 20.95s-.45-2.58-4.69-5.57-6.93-4.66-6.93-4.66-.78 6.27 3.21 9.29a63.902 63.902 0 0 0 9.21 5.57l-.8-4.63Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    d: "M35.6 293.89s-.81-2.49 1.55-7.11c2.36-4.62 4-7.35 4-7.35s3.6 5.16 1.5 9.71a65.158 65.158 0 0 1-5.58 9.24l-1.47-4.49Zm7.24 20.83s.3-2.6 4.36-5.83c4.06-3.23 6.65-5 6.65-5s1.14 6.2-2.67 9.46a64.832 64.832 0 0 1-8.87 6.1l.53-4.73Zm-1.07-6.42s-.45-2.59-4.69-5.58-6.92-4.65-6.92-4.65-.78 6.27 3.2 9.29a64.391 64.391 0 0 0 9.22 5.57l-.81-4.63Zm-.06 14.04s.23-2.62-3.12-6.58-5.52-6.27-5.52-6.27-2.34 5.85.75 9.8a65.376 65.376 0 0 0 7.5 7.75l.39-4.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177,
    d: "M21.19 244.94a73.953 73.953 0 0 0 2.39 7.85c2.7 7.13 7.1 11.28 9.68 17.7s0 15.73 2.55 24.1c2.55 8.37 6.75 12.54 6.78 18.45.03 5.91-2.25 22.24-2.25 22.24m-17.38-83.67-4.41-2.31m3.63-1.1 1.13-3.18"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.177,
    d: "M33 270.22s-3.69-1.88-7.46-3.75m4.94-1.03a52.85 52.85 0 0 1 4.27-9.86m.43 36.94a41.13 41.13 0 0 0-8.6-8.12m9.86 11.64a45.83 45.83 0 0 1 2.37-7.31c1.39-3.15 1.63-3.56 1.63-3.56m1.96 32.33a38.48 38.48 0 0 1 4.74-4.92 25.472 25.472 0 0 0 3.08-2.69m-7.63 3.15a44.86 44.86 0 0 0-4-5.43 39.058 39.058 0 0 0-4.67-4.33m7.42 23.76a11.28 11.28 0 0 0-2-5.57c-1.82-2.4-4-5.58-4.82-6.83"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#182230",
    d: "M60.52 363.44H34.26a2.002 2.002 0 0 1-2-1.95l-3.77-29.06h37.72l-3.77 29.06a2 2 0 0 1-1.92 1.95Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#182230",
    d: "M65.91 337.34H28.53a2.938 2.938 0 0 1-2.95-2.92 2.998 2.998 0 0 1 2.94-2.95h37.39a2.949 2.949 0 0 1 2.085.858 2.931 2.931 0 0 1-.96 4.792 2.929 2.929 0 0 1-1.125.22Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    d: "M336.58 399.76a131.992 131.992 0 0 1-32.84 28.35 116.286 116.286 0 0 1-12 6.26c-28.41 12.77-60.79 13.6-91.07 6.26C137 425.2 103.22 369 98.93 306.61c-1.15-16.86-3.73-35.07 3.1-51.11s20.64-26 36.26-32.92c11.34-5.05 23.59-8.44 34.72-11.21a89.307 89.307 0 0 1 60.09 6.2c13.09 6.21 22.41 17 33.42 26.09 1.167.96 2.34 1.917 3.52 2.87a329.86 329.86 0 0 0 35 24.61c18.51 11.29 37.46 21.94 49.29 40.9 18.87 30.22 2.95 63.12-17.75 87.72Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "M270 246.53a243.17 243.17 0 0 1-3.52-2.88c-11-9.11-20.34-19.87-33.42-26.08a89.368 89.368 0 0 0-60.09-6.2c-26.47 6.57-59.3 16.69-71 44.14-6.83 16-4.25 34.24-3.09 51.1C103.22 369 137 425.2 200.67 440.63c34.64 8.4 72 6.1 103.07-12.52a131.992 131.992 0 0 0 32.84-28.35c20.7-24.6 36.62-57.5 17.77-87.72-11.82-19-30.77-29.61-49.29-40.9A329.933 329.933 0 0 1 270 246.53Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M173.55 357.78a91.544 91.544 0 0 0-15.37 6.22M206 351.6c-7.743.67-15.43 1.89-23 3.65m16.25-5.25s-29.88-17.38-65.94-3.45"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M336.58 399.76a131.992 131.992 0 0 1-32.84 28.35 116.286 116.286 0 0 1-12 6.26 93.801 93.801 0 0 1-9.57-3.51c-18.66-8-34.32-21.53-49.62-34.87-9.23-8-18.61-16.2-29.66-21.47a68.216 68.216 0 0 0-47.84-3.94 53.732 53.732 0 0 1 31.64-17.41c-7.9-7.19-18.89-10.21-29.57-10.4-10.68-.19-16.56 1.12-27 3.46 3.49-6.42 12.75-12.23 20.06-12.06a181.657 181.657 0 0 1-20.78-1.47c-9.43-1.52-13.65-12.62-15.06-22.06-3.9-26 .05-53.69 14.24-75.79a77.121 77.121 0 0 1 9.7-12.27c11.34-5.05 23.59-8.44 34.72-11.21a89.307 89.307 0 0 1 60.09 6.2c13.09 6.21 22.41 17 33.42 26.09 1.167.96 2.34 1.917 3.52 2.87a329.86 329.86 0 0 0 35 24.61c18.51 11.29 37.46 21.94 49.29 40.9 18.88 30.22 2.96 63.12-17.74 87.72Z",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M347 399a193.49 193.49 0 0 0 17.57 13c11.89.8 6.56 15.17 6.56 15.17l-10.18 6.55s-17.43-13.85-26.95-18.34S347 399 347 399Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.51 247.7s-1.63-16.13-4.23-20.66L218.8 219v-3.06s.91-5.32-7.89-8.65c-8.8-3.33-27.14 1-31.87 4.58s-3 9.74-3 9.74-15.9 8.03-23.04 11.09a182.447 182.447 0 0 0-17.07 9s-3.24 37.08-2.6 45.69c.64 8.61-.52 16.71.22 21.48s1.32 7.48 6.32 11.54c5 4.06 9.55 10 22.66 4.11l-1.83-1.45L247 294l15.51-46.3Z",
    opacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M262.51 247.7s-1.63-16.13-4.23-20.66L218.8 219v-3.06s.91-5.32-7.89-8.65c-8.8-3.33-27.14 1-31.87 4.58s-3 9.74-3 9.74-15.9 8.03-23.04 11.09a182.447 182.447 0 0 0-17.07 9s-3.24 37.08-2.6 45.69c.64 8.61-.52 16.71.22 21.48s1.32 7.48 6.32 11.54c5 4.06 9.55 10 22.66 4.11l-1.83-1.45L247 294l15.51-46.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.51 247.7s-1.63-16.13-4.23-20.66L218.8 219v-3.06s.91-5.32-7.89-8.65c-8.8-3.33-27.14 1-31.87 4.58s-3 9.74-3 9.74-15.9 8.03-23.04 11.09a182.447 182.447 0 0 0-17.07 9s-3.24 37.08-2.6 45.69c.64 8.61-.52 16.71.22 21.48s1.32 7.48 6.32 11.54c5 4.06 9.55 10 22.66 4.11l-1.83-1.45L247 294l15.51-46.3Z",
    opacity: 0.05
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M258.8 229h-16.52a6.572 6.572 0 0 0-6.47 5.49l-8.14 49s-11.21.93-19.15 6.72c-7.94 5.79-27.47-35.52-58.33-35.54 0 0 8.88 20.3 10.85 36.5 0 0-19.29-2.1-22.49 5.45-3.2 7.55 1.45 21.7 9.61 16.22S164 298.22 169.45 304c5.45 5.78 29.8 8.89 29.8 8.89L236.72 294l14.53-6.83L258.8 229Z",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M206.35 204.71s9.38 2.6 10.9 5.75c1.52 3.15 1.36 11.12 1.36 11.12a38.495 38.495 0 0 1-10.09 13.88l-7-13.88.63 15.74s-13.28-2.21-18.92-6.45l-5.63-4.25s-2.43-8-2.08-10.71c.35-2.71 10.48-8.21 10.48-8.21l20.35-2.99Z",
    opacity: 0.4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M362.59 447.42c-.26-.57 3.85-7.83.63-15.22-3.22-7.39-8.35-4.54-8.35-4.54s-14.61-9.3-20.75-12.24a104.637 104.637 0 0 1-12.75-7.58l-6.49 8.74 6 18.56 41.71 12.28Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "m354.34 427.21 18.76 11.46s13.19-8.46 19.48-14.3c6.29-5.84 20.42-18.28 20.42-18.28l9-12.11s-6.24-7.72-16.64-1.52c-13.44 8-29.83 19.62-40.76 19.51 0 0 2.15 13.43-10.19 15.24"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M203.17 156.23s8.51 12.88 10.06 17.05c1.55 4.17 2.8 10.34 2.49 13.31-.31 2.97-3.43 18.88-5 19.34l-1.51 1.71 1 6.74s-6.66 11.51-26.24 3.07c0 0-.76-13.44-3.14-17.66-2.38-4.22-5.94.8-9.51-11.39-3.57-12.19 7.8-25 7.8-25l24.05-7.17Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M413.83 390.22s-9.65 1.68-12.78 7.39c-3.13 5.71-9.14 16.32-11.19 21.45-2.05 5.13-19 17.52-19 17.52l2.25 2.09s13.8-8.53 22.13-16.64c8.33-8.11 26.7-28.51 26.7-28.51s-1.32-1.31-8.11-3.3Zm-96.56 23.15-2.39 3.21 7.34 15.22 40.37 14.51 1.87-5.91s.62-6-13.55-10.56c-14.17-4.56-22.81-7.57-26.84-10.7-4.03-3.13-6.8-5.77-6.8-5.77Z",
    opacity: 0.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M184.438 299.787s-12.36-1.86-18.13 8.25-5.18 14.49-5.18 14.49 8.17 7.42 19.4 7c11.23-.42 27.58-13.28 32.91-17.47 5.33-4.19 18.77-16.18 27.94-13.7l1-8.67s-.9-3.89-8.74-2.84c-7.84 1.05-10.92 5.52-13.45 5.52-2.53 0-4.92-2.43-10 6.25-.01 0-17.84 3.16-25.75 1.17Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M200.06 174.75a35.76 35.76 0 0 0 1.12 4.79 5.59 5.59 0 0 0 1 2.11c.94 1 2.46 1.26 3.85 1.47.23.016.447.108.62.26a.998.998 0 0 1 .15.6 7.993 7.993 0 0 1-1.36 4.42"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m325.56 403-8.29 10.33s9.1 8.41 18.52 11.53c9.42 3.12 25.91 9 28.67 13.53L363.4 433s-25.79-15.82-31.71-19.6a13.666 13.666 0 0 1-6.13-10.4Z",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m354.34 427.21 16.51 9.37S379 431 383 426.89c4-4.11 8.93-8.67 12-17.88 4.19-12.73 16.19-18.79 16.19-18.79s-16.69 7.86-25.38 14c-8.69 6.14-17.16 8.74-22.08 8.32-.05.03 3.9 12.53-9.39 14.67Z",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M194.24 190.67s6.49 5.09 13.23 3.18c0 0-6.36 12.6-13.23-3.18Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M194 179.67c.19 1.4-.24 2.61-.94 2.71-.7.1-1.43-1-1.62-2.37-.19-1.37.23-2.61.94-2.71.71-.1 1.47.97 1.62 2.37Zm14.13-2.55c.18 1.41-.24 2.62-.94 2.71-.7.09-1.44-1-1.62-2.36-.18-1.36.23-2.62.94-2.71.71-.09 1.43.96 1.62 2.36Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M193 173.73s-3.78-1.95-6.47 2.23m16.16-4.83s4-3.43 6.31 0m-28.84 15.47s-2.43-3.59-5-3.48c-2.57.11-3.59 3.71-2.67 7.19.92 3.48 4.75 8.34 7.65 7.88a6.44 6.44 0 0 0 4.17-2.32"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M203.46 159.13c2.73 2.27 5.62 4.74 7 8.08 1.22 2.84 1.49 6 2.61 8.87 1.19 3.07 2.49 6.28 2.59 9.63a40.812 40.812 0 0 1-1.21 9.19 50.622 50.622 0 0 1-1.85 7.69c-1.35 3.59-3.84 5.8-7.18 7.5-2.43 1.24-6.48 3-9.11 1.34-1.53-1-3.83-3.86-5.74-6.49m-10.41-6.75s4.3 10.54 3.26 17.95"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M179.06 184.83a4.146 4.146 0 0 0 1.66-3.71c-.16-1.62-1.28-3.12-1.06-4.74a8.714 8.714 0 0 1 .86-2.22 9.304 9.304 0 0 0-.52-8.42s13.66.64 20.06-3.43c6.4-4.07 11.28-14.48 7.41-19.45-3.87-4.97-11.41 1.81-17 2.56S165 149.34 161.83 157c-3.17 7.66 1.66 10.41 1.81 17.72.15 7.31.15 21.16 11.08 19.89 0 0-4.09-5.29-1.25-10.74 1.93-2.29 5.59.96 5.59.96Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M205.85 151.5a17.145 17.145 0 0 1 6.54 12c.61 5.48 10.33 16.13 3.32 22.2 0 0-1.63-6.45-2.59-9.63-.96-3.18-2.19-9-3.8-11-1.61-2-10.15-9-10.15-9l6.68-4.57Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M181.42 215.91s6.74 4.44 19.26 4.62l1.47 16.79s-14.08-1.07-24.55-10.7c0 0-2.83-7.49-2.08-10.71.75-3.22 7.48-6.41 7.48-6.41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m209.74 208.4.4 6a24.821 24.821 0 0 1-9.46 6.15l7.84 14.93s9.35-7.28 10.28-14.93c0 0 .08-7.83-1.55-10.07-1.63-2.24-7.57-3.29-7.57-3.29"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M171.8 162c1-2.51 3.74-4 6.41-4.4 2.67-.4 5.41-.12 8.11-.19 3.739-.03 7.4-1.066 10.6-3a14.179 14.179 0 0 0 6.4-8.76",
    opacity: 0.8
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M165.35 161.51c1.69-5.13 7.17-8.3 12.56-8.75 2.67-.23 5.37.08 8-.23s5.43-1.41 6.82-3.7",
    opacity: 0.8
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M162.51 324.52c-13 6.74-17.62-.2-24.86-5.94-7.24-5.74-2.49-16-4-32.45-1.51-16.45 2.25-44.43 2.25-44.43s3.24-.74 12.23-6.24 27.91-13.88 27.91-13.88"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M175.39 299.62s-2.06-6.53-7.88-6.7c-5.82-.17-15 2.45-21.54 14.82m20.21-15.21a3.219 3.219 0 0 1-1.05-.25 25.317 25.317 0 0 0-14.94-.68m-3.35-40.97c10.59 11.7 15.75 27.18 20.64 42.18M218.8 219s19.2 4.58 28.58 5.67c9.38 1.09 10.9 2.4 10.9 2.4l1.75 6.54"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m308.27 230.38-65.39 2.51-5.34 67.25h11.2l56.78-12.71 7.14-55.44-4.39-1.61Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "m240.94 302.13 71.52-68.55-6.94 53.85-64.58 14.7Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m240.94 302.13 71.52-68.55-6.94 53.85-64.58 14.7Z",
    opacity: 0.7
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m240.94 300.33 5.72-64.87 66-3.47-7.14 55.44-64.58 12.9Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M284.84 263.42c-.44 3.95-2.55 6.95-4.71 6.71-2.16-.24-3.54-3.65-3.1-7.6.44-3.95 2.56-6.95 4.72-6.71 2.16.24 3.54 3.65 3.09 7.6Zm20.68 24.01s30.22-.86 39.67 5.38c9.45 6.24 15 37.53 13.69 54.15-1.31 16.62-12.71 54.76-12.71 54.76L324.33 377s-10.76-39.12-4.89-54.44c0 0-29 1.63-40.42-1.95 0 0-10.23-16.75-27.77-22.29l54.27-10.89Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "M350.78 402.37a149.854 149.854 0 0 1-20.78-24c-10.57-16.33-25.18-32-40.21-44.23-12.11-9.82-14.85-25.82-29.79-33.85-24.75-13.27-46.15 13.1-54.15 18.44-8 5.34-21.85 11.39-21.85 11.39s5.06 19 19.92 21.25c14.86 2.25 29.89-8 37-3.05 7.11 4.95 12.37 27.05 35.85 40 19.19 10.58 45.34 20.9 58.83 27.86 3 1.56 5.24 3.2 6.94 4.13 4.66 2.54 9.64 5.53 14.34 8.49l16.19 9.86s16.25-9.61 22.49-18.47c.83-1.19 2.56-4.36 4.18-7.42 3.53-6.69 8-12.69 14.19-16 4.28-2.31 8.09-3 8-3.24-.41-.76-8.17-4.73-13.44-2.56-11.16 4.61-33.47 22.32-44 21a78.807 78.807 0 0 1-13.71-9.6Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M350.78 402.37c-9.73 3.93-13.65 10-15.15 13.82-13.49-7-39.64-17.28-58.83-27.86-23.48-13-28.7-35.06-35.85-40-7.15-4.94-22.19 5.34-37 3.05-14.81-2.29-19.95-21.27-19.95-21.27s13.86-6 21.86-11.34 26.45-31.72 54.14-18.44c15.29 7.33 17.68 24 29.79 33.85 15 12.19 29.64 27.9 40.21 44.23a147.002 147.002 0 0 0 20.78 23.96Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M277.66 317.59s-7.49-15.22-19.5-18.17"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M238.4 287.29c-8.26-1.8-17.33 7.33-21.15 5.62-2.84-1.27-7.51 6.25-7.51 6.25a125.062 125.062 0 0 1-23.22 1.17c-11.13-.71-16.4 1.46-20.34 7.41l-5.5 14.57s14.51 13 30 5.43 36.07-30.41 50.25-30.33"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "M353.71 426.82s13.56 1.11 10.38-15.09"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M417.61 401.72c-1 2-13.43 12.58-24.14 21.83 0-.14 3-5.79 4.24-8.2 2.85-5.32 10.21-19.91 24.22-21.83 1.99 1.2-4.32 8.2-4.32 8.2Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "M412.28 390.33c-14.17 2.82-17.39 21-22.42 28.73-5.03 7.73-19 18.24-19 18.24m-7.64-4.64c2.31 4.22 1.22 9.12 0 12.19a25.46 25.46 0 0 1-2.22 4.37c-20.06-3.3-40.12-14.08-40.12-14.08l-5.17-16-.83-2.56 7.79-10.49"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M363.22 444.85a25.46 25.46 0 0 1-2.22 4.37c-20.06-3.3-40.12-14.08-40.12-14.08l-5.17-16c2.59 3.38 7.39 8.33 14.59 10.36 9.77 2.77 27.8 6.01 32.92 15.35Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m237.54 297.8 5.34-64.91 65.39-2.51 4.39 1.61"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "M364 419.06s8.94 1.6 15.81-4c6.87-5.6 17.94-18.27 17.94-18.27"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M373.1 411s-2.16 3.25 0 9.77m6.34-12.88a13.31 13.31 0 0 0 .81 9.77m6.75-14.15s-1.81 5.43 0 10.22"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeMiterlimit: 10,
    d: "m324.44 404.74-7.17 8.63s7.22 7.89 17.41 11.17c10.19 3.28 28.39 8.85 29.9 14.78"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M94.253 43.887H68.086V9h20.56l5.607 5.48v29.407Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M89.353 13.907v1.426l4.9-.846-4.9-.58Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M88.647 9v5.487h5.606L88.648 9Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M71.413 16.58h20.14m-20.14 4.987h20.14m-20.14 4.98h20.14m-20.14 4.986h20.14m-20.14 4.98h20.14M20.36 86.047h9.374m-19.734 0h8.667m7.439 2.96h3.627m-19.733 0h14.413m3.894 2.96h1.427m-9.207 0h5.413m-15.94 0h9.007M10 94.927h19.733m-3.287 2.96h3.287m-14.613 0h7.947m-13.067 0h2.753m6.254 2.96h10.727m-19.734 0h7.147m7.266 2.96h5.32m-10.56 0h3.72m-12.893 0h7.147"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M80.447 125.833h-21.58V97.06H75.82l4.627 4.513v24.26Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M76.4 101.107v1.173l4.046-.7-4.046-.473Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M75.82 97.06v4.52h4.626l-4.626-4.52Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M61.607 103.307H78.22m-16.613 4.113H78.22m-16.613 4.113H78.22m-16.613 4.107H78.22m-16.613 4.113H78.22"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#4B3BF7",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M57.76 47.114H31.593V12.227h20.56L57.76 17.7v29.414Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M52.853 17.133v1.427l4.907-.853-4.907-.574Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M52.153 12.227v5.48h5.607l-5.607-5.48Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M34.913 19.807H55.06m-20.147 4.98H55.06m-20.147 4.986H55.06M34.913 34.76H55.06m-20.147 4.98H55.06"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M113.8 63.074H87.633V28.18h20.56l5.607 5.48v29.414Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M108.9 33.087v1.433l4.9-.853-4.9-.58Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M108.194 28.18v5.487h5.606l-5.606-5.487Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M90.96 35.767h20.14m-20.14 4.98h20.14m-20.14 4.986h20.14m-20.14 4.98h20.14M90.96 55.7h20.14"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M148.907 101.74H122.74V66.847h20.56l5.607 5.48v29.413Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M144 71.753v1.434l4.907-.854-4.907-.58Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M143.3 66.847v5.486h5.606l-5.606-5.486Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M126.06 74.433h20.147m-20.147 4.98h20.147M126.06 84.4h20.147m-20.147 4.98h20.147m-20.147 4.987h20.147"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M75.887 38.113H47.093a5.74 5.74 0 0 0-5.74 5.74V78.08a5.74 5.74 0 0 0 5.74 5.74h28.794a5.74 5.74 0 0 0 5.74-5.74V43.853a5.74 5.74 0 0 0-5.74-5.74Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M77.146 38.114H45.813a4.473 4.473 0 0 0-4.474 4.473v.966h40.267v-.96a4.473 4.473 0 0 0-4.46-4.48Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M47.1 51.54h28.767M47.1 58.567h28.767M47.1 65.6h28.767M47.1 72.633h28.767"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.34 40.673a1.28 1.28 0 1 0-2.559 0 1.28 1.28 0 0 0 2.559 0Zm4.24 0a1.28 1.28 0 1 0-2.559 0 1.28 1.28 0 0 0 2.559 0Zm4.207 0a1.28 1.28 0 1 0-.785 1.183 1.274 1.274 0 0 0 .785-1.183Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M48.287 75.54H31.84a5.74 5.74 0 0 0-5.74 5.74v20.213a5.74 5.74 0 0 0 5.74 5.74h16.447a5.74 5.74 0 0 0 5.74-5.74V81.28a5.74 5.74 0 0 0-5.74-5.74Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M50.92 75.553H29.2a3.1 3.1 0 0 0-3.1 3.1v.667h27.907v-.666a3.1 3.1 0 0 0-3.087-3.1Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M30.087 84.847h19.947M30.087 89.72h19.947M30.087 94.6h19.947m-19.947 4.874h19.947"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.027 78.193a.887.887 0 1 0 0-1.773.887.887 0 0 0 0 1.773Zm2.92 0a.887.887 0 1 0 0-1.773.887.887 0 0 0 0 1.773Zm3.807-.886a.887.887 0 1 0-1.774 0 .887.887 0 0 0 1.774 0Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M39.913 116.773h9.374m-19.74 0h8.673m7.44 2.96h3.627m-19.74 0h14.42m3.887 2.96h1.433m-9.207 0h5.406m-15.939 0h9.013m-9.013 2.96h19.74M46 128.613h3.287m-14.613 0h7.94m-13.067 0h2.76m6.253 2.96h10.727m-19.74 0H36.7m7.267 2.96h5.32m-10.561 0h3.72m-12.899 0H36.7m69.473-21.74h9.38m-19.739 0h8.673m7.433 2.967h3.634m-19.74 0h14.42m3.886 2.96h1.434m-9.207 0h5.406m-15.939 0h9.013m-9.013 2.96h19.74m-3.294 2.96h3.293m-14.62 0h7.946m-13.065 0h2.753m6.26 2.96h10.727m-19.74 0h7.153m7.266 2.96h5.32m-10.559 0h3.72m-12.9 0h7.153m25.139-84.913h9.374m-19.74 0h8.673m7.44 2.96h3.627m-19.74 0h14.42m3.887 2.96h1.433m-9.206 0h5.407m-15.941 0h9.013m-9.013 2.96h19.74m-3.287 2.96h3.287m-14.613 0h7.94m-13.067 0h2.76m6.254 2.96h10.727m-19.741 0h7.153m7.267 2.96h5.32m-10.56 0h3.72m-12.9 0h7.153M25.267 52.333h9.374m-19.741 0h8.673m7.44 2.961h3.626m-19.739 0h14.42m3.894 2.959h1.426m-9.207 0h5.414m-15.947 0h9.013M14.9 61.214h19.74m-3.286 2.959h3.287m-14.614 0h7.946m-13.073 0h2.76m6.254 2.96H34.64m-19.74 0h7.153m7.267 2.96h5.32m-10.56 0h3.72m-12.9 0h7.153"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M83.887 75.787V105.2h26.166V70.313H89.5l-5.613 5.474Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M88.793 75.22v1.427l-4.906-.847 4.906-.58Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M89.493 70.313V75.8h-5.606l5.606-5.487Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M106.733 77.893H86.587m20.146 4.98H86.587m20.146 4.987H86.587m20.146 4.987H86.587"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M110.053 97.06H83.887v8.147h26.166V97.06Zm4.04-18.987H95.986v8.72h18.107v-8.72Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103.42 79.307c.927 0 1.334.546 1.334 1.433v.707c.029.185.016.375-.039.554a1.234 1.234 0 0 1-1.295.859h-.58v2.32h-.666v-5.873h1.246Zm-.046 2.966c.486 0 .72-.226.72-.786v-.78c0-.534-.194-.807-.667-.807h-.627v2.373h.574Zm3.299-2.966c.914 0 1.334.553 1.334 1.46v2.96c0 .9-.42 1.453-1.334 1.453h-1.4v-5.873h1.4Zm0 5.273c.467 0 .667-.293.667-.827v-3.02c0-.54-.227-.833-.7-.833h-.707v4.667l.74.013Zm3.92-2.54v.593h-1.333v2.547h-.667v-5.873h2.334v.593h-1.68v2.14h1.346Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M239.455 112.173a1.226 1.226 0 0 1 .864.349 1.202 1.202 0 0 1 .362.858v7.627a1.23 1.23 0 0 1-1.23 1.142 1.232 1.232 0 0 1-1.23-1.142v-7.627a1.234 1.234 0 0 1 .766-1.119c.149-.06.308-.089.468-.088Zm-3.067 0a1.224 1.224 0 0 1 1.234 1.207v7.627a1.237 1.237 0 0 1-1.23 1.142 1.232 1.232 0 0 1-1.23-1.142v-7.627a1.216 1.216 0 0 1 1.226-1.207Zm-3.054 0a1.223 1.223 0 0 1 .865.349 1.217 1.217 0 0 1 .362.858v7.627a1.216 1.216 0 0 1-.362.858 1.204 1.204 0 0 1-.865.348 1.202 1.202 0 0 1-.466-.088 1.198 1.198 0 0 1-.665-.653 1.216 1.216 0 0 1-.095-.465v-7.627a1.216 1.216 0 0 1 1.226-1.207Zm-3.053 0a1.221 1.221 0 0 1 .864.349 1.202 1.202 0 0 1 .362.858v7.627a1.216 1.216 0 0 1-.362.858 1.198 1.198 0 0 1-.398.26c-.148.06-.307.09-.466.088a1.204 1.204 0 0 1-.865-.348 1.216 1.216 0 0 1-.362-.858v-7.627a1.216 1.216 0 0 1 1.227-1.207Zm-21.407 0a1.231 1.231 0 0 1 .867.348 1.231 1.231 0 0 1 .366.859v7.627a1.235 1.235 0 0 1-1.23 1.142 1.232 1.232 0 0 1-1.23-1.142v-7.627a1.222 1.222 0 0 1 1.227-1.207Zm9.173 0a1.224 1.224 0 0 1 1.234 1.207v7.627a1.237 1.237 0 0 1-1.23 1.142 1.232 1.232 0 0 1-1.23-1.142v-7.627a1.216 1.216 0 0 1 1.226-1.207Zm9.174 0a1.231 1.231 0 0 1 .866.348 1.218 1.218 0 0 1 .367.859v7.627a1.235 1.235 0 0 1-1.23 1.142 1.232 1.232 0 0 1-1.23-1.142v-7.627a1.222 1.222 0 0 1 1.227-1.207Zm-21.401 0a1.223 1.223 0 0 1 .864.349 1.202 1.202 0 0 1 .363.858v7.627a1.227 1.227 0 0 1-2.454 0v-7.627a1.217 1.217 0 0 1 1.227-1.207Zm9.173 0a1.223 1.223 0 0 1 .865.349 1.217 1.217 0 0 1 .362.858v7.627a1.226 1.226 0 1 1-2.453 0v-7.627a1.216 1.216 0 0 1 1.226-1.207Zm9.174 0a1.226 1.226 0 0 1 .864.349 1.202 1.202 0 0 1 .363.858v7.627a1.227 1.227 0 0 1-2.454 0v-7.627a1.217 1.217 0 0 1 1.227-1.207Zm-21.407 0a1.231 1.231 0 0 1 .867.348 1.234 1.234 0 0 1 .367.859v7.627a1.228 1.228 0 0 1-.367.858c-.115.112-.25.201-.399.261a1.23 1.23 0 0 1-.468.087 1.22 1.22 0 0 1-1.226-1.206v-7.627a1.216 1.216 0 0 1 1.226-1.207Zm9.174 0a1.231 1.231 0 0 1 .866.348 1.218 1.218 0 0 1 .367.859v7.627a1.228 1.228 0 0 1-.367.858c-.114.112-.25.201-.398.261a1.23 1.23 0 0 1-.468.087 1.22 1.22 0 0 1-1.227-1.206v-7.627a1.225 1.225 0 0 1 1.227-1.207Zm9.173 0a1.231 1.231 0 0 1 .867.348 1.223 1.223 0 0 1 .366.859v7.627c-.001.16-.035.318-.097.466a1.23 1.23 0 0 1-.668.653 1.23 1.23 0 0 1-.468.087 1.22 1.22 0 0 1-1.227-1.206v-7.627a1.222 1.222 0 0 1 1.227-1.207Zm-21.401 0a1.223 1.223 0 0 1 .865.349c.114.112.204.245.266.393.063.147.095.305.096.465v7.627a1.226 1.226 0 1 1-2.453 0v-7.627a1.216 1.216 0 0 1 1.226-1.207Zm-3.053 0a1.221 1.221 0 0 1 1.227 1.207v7.627a1.232 1.232 0 0 1-1.23 1.142 1.234 1.234 0 0 1-1.23-1.142v-7.627a1.224 1.224 0 0 1 .765-1.119c.149-.06.308-.089.468-.088Zm-3.06 0a1.226 1.226 0 0 1 .864.349 1.202 1.202 0 0 1 .362.858v7.627a1.226 1.226 0 1 1-2.453 0v-7.627c.001-.16.033-.318.096-.465a1.199 1.199 0 0 1 .664-.654c.148-.06.307-.089.467-.088Zm-3.053 0a1.22 1.22 0 0 1 1.226 1.207v7.627a1.235 1.235 0 0 1-1.23 1.142 1.232 1.232 0 0 1-1.23-1.142v-7.627a1.224 1.224 0 0 1 .766-1.119c.148-.06.307-.089.468-.088Zm-3.061 0a1.223 1.223 0 0 1 .864.349 1.202 1.202 0 0 1 .363.858v7.627a1.227 1.227 0 0 1-2.454 0v-7.627a1.217 1.217 0 0 1 1.227-1.207Zm-2.106 0a.665.665 0 0 0 0 .354 1.21 1.21 0 0 1 .36.853v7.627a1.205 1.205 0 0 1-.36.853 3.7 3.7 0 0 1-1.707.353c-1.386 0-2.266-.54-1.966-1.206l3.146-7.627c.206-.389.382-.792.527-1.207Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M185.373 112.173c-.235.387-.443.79-.62 1.207l-3.886 7.627c-.313.666-1.687 1.206-3.074 1.206-1.386 0-1.953-.54-1.253-1.206l7.627-7.627.873-.853c.22-.22.333-.354.333-.354Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M185.373 112.173c-.125.101-.243.21-.354.327l-.853.88-7.627 7.627c-.666.666-1.206.113-1.206-1.334 0-1.446.54-2.813 1.206-3.113l7.627-3.813c.416-.161.82-.352 1.207-.574Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M185.373 112.173a9.026 9.026 0 0 0-1.207.48l-7.627 3.047c-.666.293-1.206-.614-1.206-2.034-.001-.329.03-.657.093-.98.029-.144.067-.287.113-.426a.326.326 0 0 1 .067-.14l.08-.087a1.194 1.194 0 0 1 .853-.367h7.627a1.19 1.19 0 0 1 .853.367l.074.087c0 .04.046.066.073.06h.207v-.007Zm0-2.267a1.23 1.23 0 0 1-1.206 1.254h-7.627a1.26 1.26 0 0 1 0-2.514h7.627a1.247 1.247 0 0 1 1.123.786c.058.151.087.313.083.474Zm0-3.019a1.238 1.238 0 0 1-.342.88 1.247 1.247 0 0 1-.864.38h-7.627a1.262 1.262 0 0 1 0-2.514h7.627a1.224 1.224 0 0 1 1.123.781c.058.15.087.311.083.473Zm0-3.014a1.238 1.238 0 0 1-.342.88 1.232 1.232 0 0 1-.864.38h-7.627a1.258 1.258 0 0 1 0-2.513h7.627a1.223 1.223 0 0 1 1.206 1.253Zm0-2.986a1.23 1.23 0 0 1-1.206 1.253h-7.627a1.258 1.258 0 0 1 0-2.513h7.627a1.237 1.237 0 0 1 1.123.786c.058.151.087.312.083.474Zm0-3.047a1.238 1.238 0 0 1-.342.88 1.233 1.233 0 0 1-.864.38h-7.627a1.26 1.26 0 0 1 0-2.513h7.627a1.227 1.227 0 0 1 1.206 1.253Zm0-3.014a1.232 1.232 0 0 1-.342.878 1.241 1.241 0 0 1-.864.376h-7.627a1.257 1.257 0 0 1-1.169-1.257 1.26 1.26 0 0 1 1.169-1.256h7.627a1.237 1.237 0 0 1 1.123.786c.058.15.087.312.083.474Zm0-3.759a4.963 4.963 0 0 1-.206 1.406.288.288 0 0 1-.074.134.516.516 0 0 1-.073.093 1.188 1.188 0 0 1-.853.367h-7.627a1.183 1.183 0 0 1-.853-.367l-.08-.093c0-.034-.047-.06-.067-.054h-.2a7.295 7.295 0 0 0 1.207-.48l7.626-3.04c.66-.3 1.2.614 1.2 2.034Zm0-6.034c0 1.42-.54 2.813-1.207 3.113l-7.627 3.807c-.414.175-.817.376-1.206.6 0 0 .133-.107.353-.327l.853-.873 7.627-7.627c.667-.7 1.207-.113 1.207 1.307Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M182.993 82.52c1.333 0 1.866.54 1.173 1.206l-7.627 7.627-.88.867a4.22 4.22 0 0 0-.326.346 9.88 9.88 0 0 0 .633-1.2l4-7.626c.34-.68 1.693-1.22 3.027-1.22Zm-5.694 0c1.334 0 2.167.54 1.854 1.207l-3.334 7.626c-.199.389-.373.79-.52 1.2.01-.115.01-.231 0-.346v-.18a1.187 1.187 0 0 1-.206-.673v-7.627c0-.163.031-.324.093-.474.03-.07.068-.138.113-.2.086-.07.18-.13.28-.18a3.745 3.745 0 0 1 1.72-.353Zm-3.833 0a1.2 1.2 0 0 1 1.186 1.206v7.627a1.188 1.188 0 0 1-1.186 1.187 1.189 1.189 0 0 1-1.187-1.187v-7.627a1.2 1.2 0 0 1 1.187-1.206Zm-2.847 0a1.199 1.199 0 0 1 1.187 1.206v7.627a1.185 1.185 0 0 1-1.187 1.187 1.187 1.187 0 0 1-1.187-1.187v-7.627a1.204 1.204 0 0 1 .343-.85 1.197 1.197 0 0 1 .844-.356Zm-2.847 0a1.203 1.203 0 0 1 1.187 1.206v7.627a1.194 1.194 0 0 1-1.187 1.2 1.192 1.192 0 0 1-1.193-1.2v-7.627a1.189 1.189 0 0 1 .347-.85 1.197 1.197 0 0 1 .846-.356Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M165.753 97.2V78.046a7.444 7.444 0 0 1 7.446 7.447v4.26a7.45 7.45 0 0 1-2.181 5.266 7.437 7.437 0 0 1-5.265 2.18Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "m146.6 115.673 19.92-9.833a5.623 5.623 0 0 0 3.133-5.04v-26a5.627 5.627 0 0 0-3.133-5.04l-19.92-9.834v55.747Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M183.846 126.613h14.72m-17.66 2.58h5.887M170.6 111.687v7.36m2.58-9.934v6.627"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.4,
    d: "M360.4 59.893h3.827"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M283.6 106.333h42.569v-46.8H365.2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5.4,
    d: "M360.4 152.68h4.68"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.4,
    d: "M287.2 119.533h43.099v33.6H365.2"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M229.501 96.811c-6.156-3.528-12.6-6.74-19.521-8.27a8.194 8.194 0 0 0-2.952-.252 3.155 3.155 0 0 0-2.385 1.584c-.594 1.233 0 2.7.729 3.843 1.665 2.52 4.158 4.347 6.669 6.012 6.885 4.563 14.274 8.28 21.6 11.988-.9-5.256-2.772-9.765-4.185-14.904"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M276.697 110.374c2.016 6.804 4.437 13.572 8.379 19.467a8.088 8.088 0 0 0 1.971 2.223 3.09 3.09 0 0 0 2.817.504c1.278-.477 1.89-1.935 2.124-3.276.54-2.97 0-6.021-.657-8.955-1.8-8.1-4.59-15.849-7.353-23.625-2.961 4.437-4.752 9-7.281 13.662Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M229.412 96.668s.477 47.115 26.919 48.042c26.442.927 27.549-47.7 27.549-48.043 0 0-3.123-7.02-27.234-6.75-24.111.27-27.234 6.75-27.234 6.75Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M264.529 115.378a9.12 9.12 0 0 1-6.227 7.992 9.115 9.115 0 0 1-11.914-7.535 9.123 9.123 0 0 1 4.552-9.051 9.115 9.115 0 0 1 13.589 8.594Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M262.063 115.198a6.647 6.647 0 0 1-4.538 5.821 6.646 6.646 0 0 1-7.114-1.966 6.642 6.642 0 0 1 5.514-10.964 6.65 6.65 0 0 1 6.138 7.109Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M258.859 116.414a6.953 6.953 0 0 1-.063-1.098v-2.862l.072.126-3.447-1.989h.189l-3.447 1.935c-.09.162.126-.207.108-.171v3.942l-.09-.171 3.375 2.061h-.153a147.827 147.827 0 0 1 2.538-1.332c.317-.181.648-.334.99-.459a6.22 6.22 0 0 1-.9.567c-.576.351-1.44.9-2.52 1.485l-.072.045-.072-.045-3.42-1.989-.099-.054v-4.014s.198-.333.099-.18l3.465-1.917.099-.054.09.054 3.375 2.07h.081v.081c0 1.242-.072 2.241-.108 2.925.003.35-.027.699-.09 1.044Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M229.294 96.632h.144l.396.134 1.539.54 1.098.397 1.341.413c.954.288 2.034.657 3.267.9l1.917.486c.666.172 1.368.297 2.097.45 1.44.333 3.015.558 4.653.828a75.809 75.809 0 0 0 21.6 0c1.647-.261 3.213-.486 4.653-.819.729-.162 1.431-.287 2.097-.45l1.917-.495c1.233-.288 2.313-.657 3.276-.9.477-.144.9-.27 1.332-.404l1.107-.397 1.53-.54.396-.135.144-.044s-.045 0-.135.063l-.396.152-1.521.567-1.098.415c-.405.143-.9.27-1.332.431-.954.288-2.034.666-3.267.963l-1.917.505c-.666.17-1.368.306-2.097.467-1.449.333-3.015.567-4.662.837a74.463 74.463 0 0 1-21.663 0c-1.656-.27-3.222-.504-4.671-.846-.72-.153-1.431-.288-2.097-.459l-1.917-.504c-1.233-.296-2.304-.674-3.267-.971l-1.332-.423-1.098-.415-1.521-.576-.396-.153-.117-.017Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M229.412 96.667s3.123-6.47 27.234-6.75c24.111-.279 27.234 6.75 27.234 6.75s-24.318 11.997-54.468 0Z",
    opacity: 0.3
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M237.7 130.202a.335.335 0 0 1-.045-.072l-.117-.207-.441-.828-.306-.594-.342-.729a32.108 32.108 0 0 1-.783-1.8l-.432-1.053-.423-1.152c-.315-.792-.576-1.665-.9-2.574a75.655 75.655 0 0 1-1.602-6.021c-.486-2.16-.837-4.23-1.125-6.129a67.502 67.502 0 0 1-.585-5.049 51.386 51.386 0 0 1-.153-1.944 84.025 84.025 0 0 1-.081-1.476v-1.233.324c0 .234 0 .54.072.9s.054.9.108 1.467c.054.567.099 1.224.171 1.944.135 1.44.36 3.141.63 5.04s.666 3.951 1.134 6.111c.468 2.16 1.035 4.176 1.584 6.003.306.9.558 1.8.9 2.574l.414 1.161.423 1.053c.252.675.522 1.269.756 1.8l.324.738.297.603.405.837.099.216.018.09Zm12.744 11.33a2.31 2.31 0 0 1-.423-.054 7.341 7.341 0 0 1-1.125-.27 11.442 11.442 0 0 1-1.602-.612 13.223 13.223 0 0 1-1.8-1.062 12.988 12.988 0 0 1-1.611-1.35 10.917 10.917 0 0 1-1.125-1.305 7.484 7.484 0 0 1-.63-.963 1.971 1.971 0 0 1-.198-.378s.333.504.9 1.26c.35.444.729.865 1.134 1.26a14.3 14.3 0 0 0 1.602 1.323c.572.397 1.173.749 1.8 1.053.507.249 1.03.466 1.566.648.918.306 1.512.414 1.512.45Zm5.508-16.623h-.981a9.334 9.334 0 0 1-2.628-.423 10.432 10.432 0 0 1-3.501-1.845 9.719 9.719 0 0 1-3.735-8.586c.06-.709.186-1.411.378-2.097.177-.589.4-1.164.666-1.719a9.574 9.574 0 0 1 1.494-2.223c.159-.179.327-.35.504-.513.126-.117.189-.171.198-.162.009.009-.243.252-.648.729a9.663 9.663 0 0 0-1.422 2.223 10.755 10.755 0 0 0-.639 1.71 11.09 11.09 0 0 0-.351 2.061 9.613 9.613 0 0 0 3.663 8.442c.546.436 1.131.821 1.746 1.152.543.274 1.106.509 1.683.702.843.27 1.717.43 2.601.477.621.072.972.054.972.072Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M254.809 47.68s-23.058-.279-26.658 19.71c-3.6 19.99 15.849 20.332 21.456 20.7 2.547.171 7.983.19 12.78.1 10.629-.18 18.135-2.242 20.7-12.096.305-1.158.498-2.343.576-3.537.621-10.8-6.696-25.407-28.854-24.877Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m271.531 78.091-33.489.522a6.354 6.354 0 0 1-6.453-6.3 6.36 6.36 0 0 1 6.255-6.462l33.507-.477a6.371 6.371 0 0 1 6.462 6.3 6.367 6.367 0 0 1-6.282 6.417Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M244.99 71.665a2.04 2.04 0 0 1-2.784 1.498 2.043 2.043 0 1 1 2.784-1.498Zm23.4-.378a2.04 2.04 0 0 1-1.599 1.613 2.047 2.047 0 0 1-2.101-.861 2.043 2.043 0 1 1 3.7-.751Zm-17.532-.567c.153 0 .072.73.522 1.683a4.363 4.363 0 0 0 1.08 1.422c.539.47 1.207.765 1.917.846a3.483 3.483 0 0 0 2.043-.486c.52-.305.971-.716 1.323-1.206.612-.855.666-1.566.819-1.556.153.008.117.18.117.521a3.26 3.26 0 0 1-.369 1.377 4.278 4.278 0 0 1-1.431 1.594 4.087 4.087 0 0 1-2.583.692 4.014 4.014 0 0 1-2.412-1.152 4.203 4.203 0 0 1-1.125-1.8 3.157 3.157 0 0 1-.117-1.422c.063-.36.153-.522.216-.513Zm1.035-21.546h-.324c-.216 0-.531 0-.9.072a26.13 26.13 0 0 0-3.402.567 25.23 25.23 0 0 0-4.824 1.674 24.823 24.823 0 0 0-5.292 3.348 25.126 25.126 0 0 0-6.813 9 25.244 25.244 0 0 0-1.197 3.231c-.126.396-.189.702-.252.9l-.072.234v.081-.08l.054-.244c.045-.207.099-.522.216-.9a23.054 23.054 0 0 1 1.098-3.267 24.184 24.184 0 0 1 2.529-4.5 24.304 24.304 0 0 1 14.481-9.576 23.512 23.512 0 0 1 3.456-.504h1.224l.018-.036Zm-22.554 27.658a2.496 2.496 0 0 1-.333-.72 10.453 10.453 0 0 1-.469-1.8 10.969 10.969 0 0 1-.117-1.9 2.953 2.953 0 0 1 .091-.783c.063 0 0 1.206.216 2.7.216 1.495.666 2.485.612 2.503Zm36.657-12.628c0 .055-4.41.1-9.846.1s-9.855 0-9.855-.1c0-.098 4.41-.09 9.855-.09s9.846.045 9.846.09Zm-16.812 22.464h-2.421a24.804 24.804 0 0 1-2.628-.162 29.141 29.141 0 0 1-3.177-.549 26.776 26.776 0 0 1-3.087-.9 24.514 24.514 0 0 1-2.421-1.026 15.976 15.976 0 0 1-.9-.468c-.261-.144-.486-.26-.666-.368l-.414-.252-.135-.1s.054 0 .153.063l.432.216c.18.1.405.225.675.352.27.126.567.287.9.431.675.316 1.494.657 2.421.99a31.06 31.06 0 0 0 3.078.9 30.75 30.75 0 0 0 3.159.558c.972.118 1.863.18 2.61.199h2.412l.009.116Zm28.188 12.879h-.081l-.261.1-.999.359c-.432.153-.963.333-1.593.522s-1.341.423-2.133.621l-1.251.333-1.368.315c-.9.225-1.962.405-3.033.612a70.108 70.108 0 0 1-7.047.828 69.149 69.149 0 0 1-7.083 0c-1.089-.072-2.124-.126-3.087-.234l-1.395-.144-1.287-.18c-.819-.099-1.548-.243-2.196-.351a31.72 31.72 0 0 1-1.647-.324l-1.035-.234-.27-.063h-.09.099l.27.045 1.044.198c.45.09.999.198 1.647.288.648.09 1.377.243 2.196.333l1.287.162c.441.054.9.09 1.386.135.963.099 1.998.153 3.078.216 2.178.09 4.572.09 7.074-.054s4.878-.459 7.02-.81c1.071-.198 2.088-.369 3.033-.594.468-.108.9-.198 1.368-.306l1.251-.315c.801-.189 1.512-.414 2.133-.594s1.17-.351 1.611-.495l1.008-.323.261-.082.09.037Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8E6FE",
    stroke: "#4B3BF7",
    strokeWidth: 0.281,
    d: "m221.907 56.419-.034.055.02.062 1.778 5.553-6.424-.41-.053-.004-.042.033a19.859 19.859 0 1 1 4.755-5.289Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M198.125 54.75a.625.625 0 0 1 0-1.25h1.25v-1.25a5.624 5.624 0 0 1 3.196-5.075c.362-.173.554-.47.554-.736v-.877c0-.266-.192-.563-.554-.737a5.624 5.624 0 0 1-3.196-5.075V38.5h-1.25a.625.625 0 0 1 0-1.25h13.75a.625.625 0 0 1 0 1.25h-1.25v1.25a5.626 5.626 0 0 1-3.196 5.075c-.362.173-.554.471-.554.737v.877c0 .265.192.563.554.736a5.626 5.626 0 0 1 3.196 5.075v1.25h1.25a.625.625 0 0 1 0 1.25h-13.75Zm2.5-16.25v1.25c0 .671.151 1.307.421 1.875h7.908c.27-.568.421-1.204.421-1.875V38.5h-8.75Zm3.75 7.939c0 .875-.598 1.544-1.264 1.864a4.375 4.375 0 0 0-2.486 3.947s1.082-1.623 3.75-1.849V46.44Zm1.25 0V50.4c2.668.226 3.75 1.85 3.75 1.85a4.375 4.375 0 0 0-2.486-3.948c-.666-.32-1.264-.989-1.264-1.864Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M467.287 19.067h-92.22a8.666 8.666 0 0 0-8.666 8.666v63.614a8.666 8.666 0 0 0 8.666 8.666h92.22a8.666 8.666 0 0 0 8.667-8.666V27.733a8.667 8.667 0 0 0-8.667-8.666Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M465.167 24.007h-87.98a6.173 6.173 0 0 0-6.173 6.173v58.713a6.173 6.173 0 0 0 6.173 6.174h87.98a6.174 6.174 0 0 0 6.174-6.174V30.18a6.174 6.174 0 0 0-6.174-6.173Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M463.54 35.88h-79.546v2.9h79.546v-2.9Zm0 6.826h-79.546v2.9h79.546v-2.9Zm0 6.827h-79.546v2.9h79.546v-2.9Zm0 6.834h-79.546v2.9h79.546v-2.9Zm0 6.826h-79.546v2.9h79.546v-2.9Zm0 6.827h-79.546v2.9h79.546v-2.9Zm0 6.826h-79.546v2.9h79.546v-2.9Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M392.254 52.9h-7.747v32h7.747v-32Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M404.1 61.873h-7.746V84.9h7.746V61.873Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M415.947 56.293H408.2V84.9h7.747V56.293Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M427.8 67.86h-7.746v17.046h7.746V67.86Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M439.647 56.893H431.9v28.013h7.747V56.893Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M451.5 49.513h-7.746V84.9h7.746V49.513Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M463.347 44.927H455.6V84.9h7.747V44.927Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M378.127 36.42h2.647m-2.647 3.8h2.647m-2.647 3.807h2.647m-2.647 3.806h2.647m-2.647 3.807h2.647m-2.647 3.8h2.647m-2.647 3.807h2.647m-2.647 3.806h2.647m-2.647 3.807h2.647m-2.647 3.8h2.647m-2.647 3.807h2.647m-2.647 3.806h2.647m-2.647 3.807h2.647m-2.647 3.8h2.647m82.794 1.093v2.647m-6.322-2.647v2.647m-6.319-2.647v2.647m-6.313-2.647v2.647m-6.32-2.647v2.647m-6.32-2.647v2.647m-6.314-2.647v2.647m-6.32-2.647v2.647m-6.32-2.647v2.647m-6.313-2.647v2.647m-6.32-2.647v2.647m-6.32-2.647v2.647m-6.32-2.647v2.647m-6.314-2.647v2.647"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M429.708 29.273h-17.72v2.907h17.72v-2.907Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M467.287 109.833h-92.22a8.666 8.666 0 0 0-8.666 8.667v63.613a8.666 8.666 0 0 0 8.666 8.667h92.22a8.667 8.667 0 0 0 8.667-8.667V118.5a8.667 8.667 0 0 0-8.667-8.667Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M465.167 114.78h-87.98a6.173 6.173 0 0 0-6.173 6.173v58.714a6.173 6.173 0 0 0 6.173 6.173h87.98a6.174 6.174 0 0 0 6.174-6.173v-58.714a6.174 6.174 0 0 0-6.174-6.173Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M404.334 178.967a27.007 27.007 0 0 1-5.24-53.5l1.28 6.546a20.341 20.341 0 1 0 10.474 39.214l2.14 6.313a26.92 26.92 0 0 1-8.654 1.427Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M423.46 145.047a20.372 20.372 0 0 0-23.033-13.034l-1.334-6.546a27.07 27.07 0 0 1 30.62 17.333l-6.253 2.247Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "m413.007 177.553-2.14-6.313a20.35 20.35 0 0 0 11.788-10.449 20.358 20.358 0 0 0 .806-15.731l6.273-2.267a27.048 27.048 0 0 1-1.075 20.888 27.043 27.043 0 0 1-15.652 13.872Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M447.887 131.153h-7.493v7.494h7.493v-7.494Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E0AF5",
    d: "M447.887 149.493h-7.493v7.494h7.493v-7.494Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#A8A8A8",
    d: "M447.887 167.84h-7.493v7.493h7.493v-7.493Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.6,
    d: "M451.827 135.1h12.626m-12.626 17.746h12.626m-67.059-.393h12.627m41.806 18.934h12.626"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 219.021,
    x2: 219.021,
    y1: 88.25,
    y2: 111.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 284.453,
    x2: 284.453,
    y1: 96.712,
    y2: 132.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 256.646,
    x2: 256.646,
    y1: 89.91,
    y2: 144.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 255.453,
    x2: 255.453,
    y1: 110.24,
    y2: 118.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 255.704,
    x2: 255.704,
    y1: 47.666,
    y2: 88.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevenueBro);
export default __webpack_public_path__ + "static/media/Revenue-bro.15a93b33aed9933bdbae730f134e6a19.svg";
export { ForwardRef as ReactComponent };